import { jsx } from '@emotion/react/jsx-runtime';
import { compound, createPolymorphicComponent, useSlot, useAdaptiveColorContext, useAdaptiveHeightContext } from '@nettbureau/core';
import { Icon } from '@nettbureau/icon';
import { Rectangle } from '@nettbureau/shape';
import { useCss } from '@nettbureau/styling';
import { Text } from '@nettbureau/typography';
import { ChipRemoveButton } from './chip-remove-button.js';

/**
 * Ordered list of available chip sizes.
 */ const chipSizes = [
    'xs',
    'sm'
];
/**
 * Chips are compact elements that represent an input, attribute, or action.
 */ const Chip = compound('Chip', createPolymorphicComponent((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('Chip', props, ref);
    const { children, css, color = useAdaptiveColorContext() ?? 'neutral', layout, maxWidth = '100%', size = useAdaptiveHeightContext() ?? 'xs', variant = 'soft', ...chipProps } = mergedProps;
    const chipCss = useCss({
        cursor: 'inherit'
    });
    return /*#__PURE__*/ jsx(Rectangle, {
        "data-chip": true,
        ...chipProps,
        ref: mergedRef,
        css: [
            chipCss,
            css
        ],
        fill: variant === 'soft' ? color : 'base',
        fillTone: "soft",
        layout: layout,
        maxWidth: maxWidth,
        minHeight: size,
        outline: variant === 'outlined' ? 'neutral' : undefined,
        outlineTone: variant === 'outlined' ? 'weak' : 'none',
        outlineWidth: variant === 'outlined' ? 'regular' : 'none',
        shadow: variant === 'base' ? 'weaker' : 'none',
        typography: {
            color
        },
        width: "fit-content",
        children: children
    });
}), {
    Label: Text,
    Icon: Icon,
    RemoveButton: ChipRemoveButton
});

export { Chip, chipSizes };
//# sourceMappingURL=chip.js.map
